module.exports = __webpack_public_path__ + "static/media/company24x24.0d7c8a3d.svg";